module.exports = __webpack_public_path__ + "static/media/middle_background_sabor.8d06dc60.jpg";